
import { jobs } from "@/api/jobs"
import { OtherDocumentRepository } from "../domain/OtherDocumentRepository"
import { WorkflowTemplateRepository } from "../domain/WorkflowTemplateRepository"
import { VueOtherDocumentListScreenData } from "../infra/VueOtherDocumentListScreenData"

export class OtherDocListComponent {
    
    document_repo:OtherDocumentRepository
    wf_repo: WorkflowTemplateRepository
    screen_data: VueOtherDocumentListScreenData

    constructor(document_repo:OtherDocumentRepository, screen_data: VueOtherDocumentListScreenData, wf_repo: WorkflowTemplateRepository) {
        this.document_repo = document_repo
        this.screen_data = screen_data
        this.wf_repo = wf_repo
    }

    async fetchDocTypes() {
        return await this.document_repo.getAvailableTypes()
    }

    async mount(company_id) {
        let types = await this.fetchDocTypes()
        types.filter(type => type.toLowerCase() !== 'otros').forEach(type => {
            this.screen_data.availableFilters['type']['user_values'].push(
                { 
                    value: type,
                    text: type
                }
            );
        });
        await this.searchDocuments(company_id)
        let res = await this.wf_repo.get_workflow_template()
        this.screen_data.workflowOptions.push(...Object.values(res));
        this.getCompanyFolders(company_id)
    }

    updateFilters(params) {
        Object.values(this.screen_data.availableFilters).forEach(element => {
            if (params.key === element.name) {
                element.value = params.value;
                element.text = params.text;
            }
        });
    }

    celanAllFilters() {
        Object.values(this.screen_data.availableFilters).forEach(element => {
            element.value = '';
            element.text = '';
        });
        this.screen_data.offset = 0
        this.screen_data.currentPage = 1
    }

    async searchDocuments(company_id, args={}) {
        args['company_id'] = company_id
        Object.values(this.screen_data.availableFilters).forEach(element => {
            args[element.name] = element.value;
        });
        args['limit'] = this.screen_data.limit
        args['offset'] = this.screen_data.offset
        if (this.screen_data.currentFolderUUID != null){
            args['folder_uuid'] = this.screen_data.currentFolderUUID
        }
        try {
            this.screen_data.loading_odocs = true
            let data = await this.document_repo.get_documents(args)
            this.updateData(data['data'], data['count'])
        } catch (error) {
            this.screen_data.other_documents = []
            this.screen_data.totalItems = 0
            throw error
        }
        this.screen_data.loading_odocs = false
    }

    async sortTable(company_id, value) {
        let args = {}
        if (value && value[0] === true) {
            args['order_by'] = '-' + this.screen_data.sortBy
        } else if (value && value.length === 0) {
            args['order_by'] = ''
        } else {
            args['order_by'] = value[0]
        }
        await this.searchDocuments(company_id, args)
    }


    updateData(data, count) {
        this.screen_data.other_documents = data
        this.screen_data.selectedItems = []
        this.screen_data.totalItems = count
        if(this.screen_data.totalItems > 0){
            this.screen_data.showSelect = true
        }
        this.screen_data.selectAllItems = false;
        this.calculateTableHeight();
        this.screen_data.drawer = false;
    }

    calculateTableHeight() {
        this.screen_data.initNumItemsPerPage = Math.min(this.screen_data.limit, 10);
        if (this.screen_data.totalItems == 0) {
            this.screen_data.tableHeight = '20vh';
        }
        else {
            const rowHeight = document.querySelector('.text-start') && (document.querySelector('.text-start') as HTMLElement).offsetHeight || 48;
            this.screen_data.tableHeight = (rowHeight * (Math.min(this.screen_data.totalItems, this.screen_data.initNumItemsPerPage) + 1)).toString() + 'px';
        }
    }

    async deleteDocs(company_id) {
        let items_to_delete = this.screen_data.selectedItems.map(({id})=> id)
        let res = await this.confirm()
        if (res) {
            this.screen_data.loading_d_other_doc = true
            let args = { document_ids: items_to_delete, cascade_entities: this.screen_data.cascadeEntities }
            await this.document_repo.deleteDocuments(args)
            this.screen_data.loading_d_other_doc = false
            this.screen_data.selectedItems = []
            this.screen_data.cascadeEntities = false
            await this.searchDocuments(company_id)
        }
    }

    async moveDocumentsToFolder() {
        let docs_to_move = this.screen_data.selectedItems.map(({id})=> id)
        let selected_folder = await this.userSelectsFolder();
        if (selected_folder == null) { // '' for root 
            return;
        }
        let args = { folder_uuid: selected_folder, doc_ids: docs_to_move}
        await this.document_repo.moveDocsToFolder(args)
    }

    async goToFolder(company_id){
        let selected_folder = await this.userSelectsFolder();
        if (selected_folder == null) { // '' for root
            return;
        }
        this.screen_data.currentFolderUUID = selected_folder+ ""
        this.screen_data.currentFolderRoute = this.getFolderRoute(this.screen_data.companyFolders, '',selected_folder)
        this.searchDocuments(company_id)
    }

    getFolderRoute(folders, so_far_route ,folder_uuid){
        for (let i = 0; i < folders.length; i++) {
            let folder = folders[i];
            if (folder.id == folder_uuid) {
                return so_far_route + folder.name;
            }
            if (folder.children) {
                let current_route = folder.name =='/'? folder.name:so_far_route + folder.name + '/'
                let found_route = this.getFolderRoute(folder.children, current_route, folder_uuid);
                if (found_route) {
                    return found_route;
                }
            }
        }


    }

    confirm(){
        this.screen_data.showDeletePupup = true;
        return new Promise((resolve,reject)=>{
            this.screen_data.resolvePopupPromise = resolve
        })
    }

    async downloadDocs() {
        let doc_ids = this.screen_data.selectedItems.map(({id})=> id)
        if (this.screen_data.selectedItems.length == 1) {
            this.screen_data.documentName = this.screen_data.selectedItems[0].original_file_name
        } else {
            this.screen_data.documentName = 'listado_documentos.zip'
        }
        this.screen_data.action = 'download'
        let args = { doc_ids: doc_ids }
        let res = await this.document_repo.downloadDocuments(args)
        this.screen_data.asyncJobState = 'running';
        this.screen_data.asyncJobId = res.job_id
    }

    async changeWorkflow() {
        let args = {
            doc_ids: this.screen_data.selectedItems.map(({id})=> id),
            wf_id: this.screen_data.selectedWorkflow
        }
        console.log('args', args)
        let res = await this.document_repo.changeDocsWorkflow(args)
        this.screen_data.asyncJobState = 'running';
        this.screen_data.asyncJobId = res.job_id;
        this.screen_data.dialogChangeWorkflow = false;
        this.screen_data.selectedWorkflow = undefined;
    }

    async jobDone(company_id){
        const response = await jobs.getJob({ id: this.screen_data.asyncJobId });
        this.screen_data.asyncJobState = response.data.state;
        let recived_url = response.data.output_info;
        if (this.screen_data.action == 'download') {
            const res = await fetch(recived_url)
            const blob = await res.blob();
            const url = await URL.createObjectURL(blob)
            const a = document.createElement("a");
            a.href = url;
            a.download = this.screen_data.documentName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } else if (this.screen_data.action == 'changeWorkflow') {
            if (this.screen_data.asyncJobState == 'done') {
                this.searchDocuments(company_id)
            }
        }
    }

    // async saveFolder() {
    //     let new_folder_form = await this.user_fills_folder_form();
    //     if (!new_folder_form) {
    //         return;
    //     }
    //     let args = {
    //         folder_name: new_folder_form.folder_name,
    //         parent_folder_uuid: new_folder_form.parent_folder_uuid,
    //         company_id: this.screen_data.company_id
    //     }
    // }

    async getCompanyFolders(company_id) {
        let args = { company_id: company_id }
        let folder_map =  await this.document_repo.getCompanyFolders(args)
        this.screen_data.companyFolders = [{'name':'/','id':'', 'children': folder_map}]
    }

    userSelectsFolder() {
        this.screen_data.popUpSelectFolder = true;
        return new Promise((resolve) => {
            this.screen_data.resolveSelectedFolderPromise = resolve;
        });
    }
    confirmFolderPopUp(folder_uuid) {
        this.screen_data.popUpSelectFolder = false;
        if (this.screen_data.resolveSelectedFolderPromise) {
            this.screen_data.resolveSelectedFolderPromise(folder_uuid);
            this.screen_data.resolveSelectedFolderPromise = null;
        }
    }
    cancelFolderPopUp() {
        this.screen_data.popUpSelectFolder = false;
        if (this.screen_data.resolveSelectedFolderPromise) {
            this.screen_data.resolveSelectedFolderPromise(null);
            this.screen_data.resolveSelectedFolderPromise = null;
        }
    }
    async chooseFolder() {
        let selected_folder = await this.userSelectsFolder();
        console.log('Selected folder:', selected_folder);
    }
    async createFolder(companydb_id, selected_folder_parent) {
        let args = {}
        args['name'] = this.screen_data.newFolderName
        args['company_id'] = companydb_id
        args['parent_uuid'] = selected_folder_parent? selected_folder_parent: null

        let uuid_new_folder = await this.document_repo.saveFolder(args)
        await this.getCompanyFolders(companydb_id)
        this.screen_data.popUpCreateFolder = false;
    }
    showPopUpCreateFolder() {
        this.screen_data.popUpCreateFolder = true;
    }
    cancelCreateFolder() {
        this.screen_data.popUpCreateFolder = false;
    }
}